:host {
  // disable section paddings and margins
  --stzh-section-padding-top: 0px;
  --stzh-section-padding-bottom: 0px;
  --stzh-section-margin-top: 0px;
  --stzh-section-margin-bottom: 0px;

  --margin-left: inherit;
  --margin-right: inherit;
}

.stzh-accordion {
  display: grid;
  gap: space('xsmall');
  margin-left: var(--margin-left);
  margin-right: var(--margin-left);

  &__heading {
    @include spaceCurve('margin-bottom', 'small');
  }

  /* is nested within another accordion */

  &--is-nested {
    @include spaceCurve('margin-left', 'regular', true);
    @include spaceCurve('margin-right', 'regular', true);
  }
}
